import { useContext, useState } from 'react'
import UserContext from 'src/provider/state-manager/userProvider'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import ApiContext from 'src/provider/API/call-service'
import { AppSpan, AppText, Button, CustomContainer, FlexColumn, FlexRow, Form, FormGroup, FormGroupWithIcon, ScreenContainer } from "src/style"
import { useNavigate } from 'react-router-dom'
import { FiChevronDown } from 'react-icons/fi'
import { IoArrowBackOutline } from 'react-icons/io5'
import { handleTypeNumberControl } from 'src/utils/utility'


export const ReferralD2: React.FC<any> = () => {
    const navigate = useNavigate()
    const {API} = useContext(ApiContext)
    const {info: {institutionData}} = useContext(AppInfoContext)
    const {user: {onboardingInput}, setUserProperty} = useContext(UserContext)
    const [input, setInput] = useState({
        referral: onboardingInput.referral || '', 
        referralCode: onboardingInput.referralCode || '', 
        informationSource: onboardingInput.informationSource || '',
        referralName: onboardingInput.referralName || '',
        referralPhoneNo: onboardingInput.referralPhoneNo || ''
    })

    let isRfsFlow = institutionData.onboardingFlow === 'RFS'

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) => setInput({...input, [e.target.name]: e.target.value})

    async function handleSubmit(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        await setUserProperty('onboardingInput', {...onboardingInput, ...input})
        
        const response = isRfsFlow ? await API.onboardNonNGNewCustomer() : await API.onboardCustomer()
        if (response) navigate('/onboarding/profile-setup-completion')
    }

    return (
        <ScreenContainer padding='2.5' height='auto' sizeUnit=''>
            <FlexColumn 
                justifyContent='flex-start'
                className='onboarding-screen-container-d2'
            >
                <AppText 
                    textSize='3' color='#101828' 
                    bottomMargin='1.5' fontFamily='Gilmer-Bold'
                >
                    Referral
                </AppText>
                <AppSpan>How did you get to know about Us?</AppSpan>
                <Form topMargin='2.5' onSubmit={handleSubmit}>
                    { !isRfsFlow ?
                        <>
                            <FormGroupWithIcon bottomMargin='2'>
                                <label>Referred By</label>
                                <div className="input-with-icon">
                                    <select 
                                        placeholder="Select Referral Type"
                                        name='referral'
                                        value={input.referral}
                                        style={{color: input.referral ? '#000000' : '#667085'}}
                                        onChange={handleInput}
                                    >
                                        <option value="">Select Referral Type</option>
                                        <option value="1">Staff</option>
                                        <option value="2">Friend</option>
                                        <option value="0">Not Applicable</option>
                                    </select>
                                    <FiChevronDown className="input-with-icon-tag" />
                                </div>
                            </FormGroupWithIcon>
                            <FormGroup>
                                <label>Referral Code</label>
                                <input 
                                    placeholder='Enter Referral Code' 
                                    name='referralCode'
                                    value={input.referralCode}
                                    onChange={handleInput}
                                />
                            </FormGroup>
                            <FormGroupWithIcon bottomMargin='2'>
                                <label>How did you hear about us (Optional)</label>
                                <div className="input-with-icon">
                                    <select 
                                        placeholder="Select"
                                        name='informationSource'
                                        value={input.informationSource}
                                        style={{color: input.informationSource ? '#000000' : '#667085'}}
                                        onChange={handleInput}
                                    >
                                        <option value="">Select</option>
                                        <option value="1">Newspaper</option>
                                        <option value="2">Social media</option>
                                        <option value="3">Staff</option>
                                        <option value="4">Friend</option>
                                        <option value="0">None</option>
                                    </select>
                                    <FiChevronDown className="input-with-icon-tag" />
                                </div>
                            </FormGroupWithIcon>
                        </>
                        :
                        <>
                            <FormGroup>
                                <label>Referral Name</label>
                                <input 
                                    placeholder='Enter Referral Name' 
                                    name='referralName'
                                    value={input.referralName}
                                    onChange={handleInput}
                                />
                            </FormGroup>
                            <FormGroup>
                                <label>Referral Phone Number</label>
                                <input 
                                    placeholder='Enter Referral Phone Number' 
                                    name='referralPhoneNo'
                                    type='number'
                                    value={input.referralPhoneNo}
                                    onChange={handleInput}
                                    onKeyDown={handleTypeNumberControl}
                                    onKeyUp={handleTypeNumberControl}
                                />
                            </FormGroup>
                        </>
                    }
                    
                    <FlexRow justifyContent='flex-end' topMargin='1.5' gap='1.5'>
                        <Button 
                            width='9.3' height='4' bgColor="#ffffff"
                            borderColor='#D0D5DD' hoverBgColor='#ffffff' 
                            hoverColor='#0D968F' titleSize='1.4' color="#344054"
                            childHoverColor='#0D968F' type="button"
                            onClick={() => navigate(-1)}
                        >
                            <AppSpan color='#344054' rightMargin='1' textSize='1.6'>
                                <IoArrowBackOutline/>
                            </AppSpan>
                            Back
                        </Button>
                        <Button 
                            width='8.8' height='4'
                            borderColor='#0D968F' hoverBgColor='#fff' 
                            hoverColor='#0D968F' titleSize='1.4'
                        >
                            Proceed
                        </Button>
                    </FlexRow>
                </Form>
            </FlexColumn>
        </ScreenContainer>
    )
}
